var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63743 3.5C7.27231 3.5 6.30837 4.83739 6.74006 6.13246L7.95154 9.76689C6.36361 10.3697 5.25 11.9046 5.25 13.6842V15.5C5.25 16.0523 5.69772 16.5 6.25 16.5H11.25V20.5C11.25 21.0523 11.6977 21.5 12.25 21.5C12.8023 21.5 13.25 21.0523 13.25 20.5V16.5H18.25C18.8023 16.5 19.25 16.0523 19.25 15.5V13.6842C19.25 11.9046 18.1364 10.3697 16.5485 9.76689L17.7599 6.13246C18.1916 4.83739 17.2277 3.5 15.8626 3.5H8.63743ZM12.25 14.5H17.25V13.6842C17.25 12.5363 16.3635 11.5833 15.2187 11.5004C14.5472 11.4517 14.1014 10.7835 14.3143 10.1448L15.8626 5.5H8.63743L10.1857 10.1448C10.3986 10.7835 9.95281 11.4517 9.28134 11.5004C8.13647 11.5833 7.25 12.5363 7.25 13.6842V14.5H12.25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinOutlined);
export default __webpack_public_path__ + "static/media/pin_outlined.503caa17b93d1a9aa3d2a13c36283b03.svg";
export { ForwardRef as ReactComponent };